require('node_modules/@odx/customer-portal-ui-core/src/main.js');
